import React from "react";
import "./App.css";

import { Router, Route, Switch } from "react-router-dom";
import Subscribe from "./frontend/Subscribe";
import SubscriptionConfirm from "./frontend/SubscriptionConfirm";
import { createBrowserHistory } from "history";
import UnSubscribe from "./frontend/UnSubscribe";
import UpdateDetails from "./frontend/UpdateDetails";
import Newsletters from "./frontend/Newsletters";
import UploadNewsletter from "./frontend/UploadNewsletter";
import UnSubscribeSuccessful from "./frontend/UnSubscribeSuccessful";
import Register from "./frontend/Register";
import Login from "./frontend/Login";
import Admin from "./frontend/Admin";
import SendEmailConfirm from "./frontend/SendEmailConfirm";
import HomeScreen from "./frontend/HomeScreen";
import DeleteNewsletterConfirm from "./frontend/DeleteNewsletterConfirm";
import vulekamaliImage from "./Vulekamali.png";

const history = createBrowserHistory();

function App() {
  return (
    <>
      <Router history={history}>
        <div className="Page flex items-center justify-center">
          <h1 className="Title">Vulekamali Newsletter</h1>
          <Switch>
            <Route exact path="/" component={Subscribe} />
            <Route exact path="/Home" component={HomeScreen} />
            <Route
              exact
              path="/SubscriptionConfirm/:email"
              component={SubscriptionConfirm}
            />
            <Route
              exact
              path="/DeleteNewsletterConfirm/:id"
              component={DeleteNewsletterConfirm}
            />
            <Route path="/UnSubscribe/:email" component={UnSubscribe} />
            <Route
              path="/UnSubscribeSuccessful/:email"
              component={UnSubscribeSuccessful}
            />

            <Route
              exact
              path="/UpdateDetails/:email"
              component={UpdateDetails}
            />
            <Route
              exact
              path="/SendEmailConfirm/:id"
              component={SendEmailConfirm}
            />

            <Route exact path="/Subscribe" component={Subscribe} />
            <Route exact path="/Register" component={Register} />
            <Route exact path="/Login" component={Login} />
            <Route exact path="/Admin" component={Admin} />

            <Route exact path="/Newsletters" component={Newsletters} />
            <Route
              exact
              path="/UploadNewsletter"
              component={UploadNewsletter}
            />
          </Switch>

          <img
            src={vulekamaliImage}
            className="object-cover w-full h-full"
            alt=""
          />
        </div>
      </Router>
    </>
  );
}

export default App;
